import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import { branchListReducer } from "./reducers/branchReducers";
import { eventListReducer } from "./reducers/eventReducers";
import { genderListReducer } from "./reducers/genderReducers";
import { maritalStatusListReducer } from "./reducers/maritalStatusReducers";
import { countryListReducer } from "./reducers/countryReducers";
import { fieldsListReducer } from "./reducers/fieldofStudyReducers";
import { financialListReducer } from "./reducers/financialReducers";
import { intakeListReducer } from "./reducers/intakeReducers";
import {
  studylevelListReducer,
  studyLevelsetReducer,
} from "./reducers/studylevelReducers";
import {
  createContactReducer,
  contactListReducer,
  createContactReducer2,
  contactDetailsReducer,
} from "./reducers/contactReducers";
import {
  activityCreateDetailsReducer,
  activityDetailsReducer,
  activityUpdateDetailsReducer,
} from "./reducers/activityReducer";

const reducer = combineReducers({
  contactList: contactListReducer,
  createContact: createContactReducer,
  contactDetailsReducer,
  createContact2: createContactReducer2,
  branchList: branchListReducer,
  eventList: eventListReducer,
  genderList: genderListReducer,
  maritalStatusList: maritalStatusListReducer,
  countryList: countryListReducer,
  fieldsList: fieldsListReducer,
  financialList: financialListReducer,
  intakeList: intakeListReducer,
  studylevelList: studylevelListReducer,
  studyLevelset: studyLevelsetReducer,
  activityDetailsReducer,
  activityUpdateDetailsReducer,
  activityCreateDetailsReducer,
});

const initialState = {};

const middleware = [thunk];

const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
